<template>
  <div class="game-table-flush">
  <vue-good-table 
    styleClass="vgt-table condensed vgt-flush"
    v-bind="tableOptions"
    :columns="columns"
    :rows="rows"
    :pagination-options="paginationFor(rows)"
    :sort-options="sortOptions"
    :row-click="true"
    @row-click="goToFinishedGame"
    compactMode>     
    <template #table-row="props">
      <div v-if="props.column.field == 'GameName'" class="d-flex align-items-center gap-2">
        <img
          v-if="props.row.GameRewardImg"
          :src="rewardSrc(props.row.GameRewardImg)"
          class="reward-thumb reward-img"
          :alt="props.row.GameName"
          role="button"
          @click.stop="openRewardPhoto(props.row)"
        >
        <span>{{ props.row.GameName }}</span>
      </div>
      <button
        v-else-if="props.column.field == 'action'"
        class="my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right"
      >
        <i class="ni ni-bold-right" aria-hidden="true"></i>
      </button>
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
    <template #emptystate>
      <div class="text-center">
        <span>Žádné ukončené hry</span>
      </div>
    </template>
  </vue-good-table>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { tableOptions, paginationFor, czechDateColumn } from '../../../../helpers/tableOptions';

const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);
const apiRoot = computed(() => process.env.VUE_APP_API_URL);
const rewardSrc = (value) => {
  if (!value) return '';
  if (String(value).startsWith('img/')) return apiRoot.value + value;
  return imgRoot.value + value;
};

const openRewardPhoto = (row) => {
  const src = rewardSrc(row?.GameRewardImg);
  if (!src) return;
  store.dispatch('openLightbox', { src, alt: row.GameName || 'Výhra' });
};

const props = defineProps({
  rows: Array
});

const store = useStore();
const router = useRouter();

const user = computed(() => store.getters.getUser);

const formatFn = (value) => { return store.getters.formatTableNumber(value) };

const sortOptions = {
  enabled: true,
  initialSortBy: { field: 'GameTo', type: 'desc' }
};

const goToFinishedGame = (params) => {
  router.push({name: "Ukončená hra", query: { hrac: user.value.UserNickName }, params: { gid: params.row.GameID, pid: user.value.UserID }});
}

const columns = reactive([
  { 
    label: 'Hra',
    field: 'GameName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold align-middle td-middle',
  },
  { 
    label: 'Konec hry',
    field: 'GameTo',
    ...czechDateColumn,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  {
    label: "Pořadí",
    field: "Rank",
    thClass: "text-uppercase text-dark text-xxs font-weight-bolder text-center",
    tdClass: "text-sm font-weight-bold text-center",
    width: "150px",
  },
  {
    label: "Výhra",
    field: "Reward",
    type: "number",
    formatFn: formatFn,
    thClass: "text-uppercase text-dark text-xxs font-weight-bolder",
    tdClass: "text-sm font-weight-bold",
    width: "140px",
  },
  {
    label: "Hodnota portfolia",
    field: "PortfolioAmount",
    type: "number",
    formatFn: formatFn,
    thClass: "text-uppercase text-dark text-xxs font-weight-bolder",
    tdClass: "text-sm font-weight-bold",
  },
  {
    label: "Detail",
    field: "action",
    thClass: "text-uppercase text-dark text-xxs font-weight-bolder text-end",
    tdClass: "text-sm font-weight-bold text-end",
  },
]);

</script>

<style scoped>
:deep(td.td-middle) {
  vertical-align: middle !important;
}

.reward-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 0.45rem;
  flex-shrink: 0;
  cursor: zoom-in;
}
</style>